<template>
  <div class="container">
    <div class="columns">
      <div class="column col-2 col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
        <button class="btn btn-sm btn-link" @click.prevent="toggleModal"><i class="icon icon-plus"></i>Create new matter</button>
      </div>
      <div class="column col-6 col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-6">
        <div class="input-group">
          <span class="input-group-addon">Filter</span>
          <input type="text" class="form-input" v-model="filter" />
        </div>
      </div>
      <div class="column col-4 col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-6">
        <div class="form-group">
          <label class="form-switch">
            <input type="checkbox" v-model="showArchived">
            <i class="form-icon"></i> Show Archived
          </label>
        </div>
      </div>
    </div>
    
    <div class="divider"></div>

    <matter-table :rows="matters" :filter="filter" :showArchived="showArchived"></matter-table>

    <!-- NEW MATTER MODAL -->
    <div class="modal" id="editMatter" v-bind:class="{active: showModal}">
      <div class="modal-overlay"></div>
      <div class="modal-container" style="width:64rem;">

        <div class="modal-header">
          <button class="btn btn-clear float-right" @click.prevent="toggleModal"></button>
          <div class="modal-title h4">Create a new matter</div>
        </div>

        <div class="modal-body" style="overflow: visible">
          <div class="content">

            <form class="form-horizontal">

              <div class="form-group">
                <div class="col-3">
                  <label class="form-label">Client</label>
                </div>

                <div class="col-9">
                  <searchClients v-on:selected="selectClient"></searchClients>
                </div>
              </div>

              <div class="form-group">
                <div class="col-3">
                  <label class="form-label" for="editqtype">Type</label>
                </div>
                <div class="col-9">
                  <select class="form-select" id="editqtype" v-model="selectedVisatype">
                    <option value="" selected>Select</option>
                    <option v-for="type in visatypes" :value="type">{{type.name}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <div class="col-3"></div>
                <div class="col-9">
                  <button class="btn btn-primary" @click.prevent="makeNewMatter" :class="{loading: loading}">Save</button>
                  <span v-if="newMatterErr" class="label label-error">{{newMatterErr}}</span>
                </div>
              </div>

            </form>
          </div>

        </div>
        <div class="modal-footer">
          
        </div>
      </div>
    </div>
    <!-- END NEW MATTER MODAL -->

  </div>
</template>

<script>
import axios from 'axios'
import matterTable from '@/components/table'
import searchClients from '@/components/users/searchClients'
export default {
  name: 'matters',
  components: {
    'matter-table': matterTable,
    'searchClients': searchClients
  },
  data () {
    return {
      matters: [],
      visatypes: [],
      selectedUser: null,
      selectedVisatype: '',
      filter: '',
      newMatterErr: '',
      showArchived: false,
      showModal: false,
      loading: false
    }
  },
  created: function () {
    this.$root.$data.pageTitle = 'Matters'
    this.getMatters()
    this.getTypes()
  },
  watch: {
    showArchived: function () {
      this.$root.$data.pageTitle = this.showArchived ? 'Archived Matters' : 'Matters'
    }
  },
  methods: {
    selectClient: function (user) {
      this.selectedUser = user
    },
    getMatters: function () {
      axios.get('/api/matters/all').then(res => {
        if (res.status === 200) {
          this.matters = res.data.map(m => {
            return [
              m._id,
              m.username,
              m.mattername,
              m.stage,
              new Date(m.due),
              m.owner,
              m.nextstep,
              new Date(m.deadline),
              m.deadlinenote,
              m.sponsor,
              m.dependents,
              m.archived,
              m.user_archived,
              m.visatype]
          })
        }
      })
    },
    getTypes: function () {
      axios.get('/api/allvisatypes').then(res => {
        if (res.status === 200) {
          this.visatypes = res.data
        }
      })
    },
    makeNewMatter: function () {
      this.loading = true
      this.newMatterErr = ''

      // Set the due date to be one week from now
      let week = 1000 * 60 * 60 * 24 * 7
      let due = new Date()
      due.setTime(due.getTime() + week)

      // Set the matter's username (a person or a business)
      let p = this.selectedUser.profile
      let username = p.corporate ? p.business : p.firstname + ' ' + p.lastname

      axios.post('/api/matters/new', {
        visatype: this.selectedVisatype._id,
        user: this.selectedUser._id,
        username: username,
        mattername: this.selectedVisatype.name,
        due: due
      }).then(res => {
        if (res.status === 200) {
          this.loading = false
          this.getMatters()
          this.toggleModal()
        }
      }).catch(e => {
        this.loading = false
        console.log(e)
        if (e.response) {
          // A regular error
          this.newMatterErr = e.response.data
        } else {
          // We expect a network error
          this.toggleModal()
        }
      })
    },
    delMatter: function (key) {
      var vm = this
      axios.post('/api/matters/delete/' + this.matters[key]._id).then(function (res) {
        vm.getMatters()
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    toggleModal: function () {
      this.showModal = !this.showModal
    }
  }
}
</script>
<style scoped>
.container {
  max-width: 100%
}
.cell select {
  width: 100%;
}
#datebox {
  max-width: 367px;
}
button.btn.btn-sm.btn-link {
  background: #D04881;
  color: #fff;
}
button.btn.btn-sm.btn-link i {
  margin: 0 0.5em 0 0;
}
button.btn.btn-sm.btn-link:hover {
  background-color: #b9336b
}
.input-group .input-group-addon {
  line-height: 16px !important;
  padding: 5px .4rem !important;
  height: 29px !important;
  font-size: 0.8em !important;
}
input.form-input {
  height: 29px;
}
.form-switch {
  font-size: 0.7em;
}
</style>



// WEBPACK FOOTER //
// matters.vue?29ea8ec4